import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import MessageThread from '../components/conversations/MessageThread';
import type { Conversation } from '../components/conversations/types';

// Deep-link fallback for /crm/conversations/:id. The primary UX is the 3-pane
// inbox (Conversations.tsx); this renders the same thread for a bookmarked id.
// We only know the id here, so the thread loads messages live and stays read-only.
export default function ConversationDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const conversation: Conversation | null = id
    ? {
        id,
        contact_id: null,
        contact_apex_id: null,
        contact_name: null,
        phone: null,
        email: null,
        company_name: null,
        channel: 'other',
        unread_count: 0,
        last_message_body: null,
        last_message_date: null,
        last_message_direction: null,
        owner_id: null,
        tags: [],
        persona_label: null,
        persona_role: null,
        persona_intent: null,
        persona_status: null,
      }
    : null;

  return (
    <Layout>
      <button
        onClick={() => navigate('/crm/conversations')}
        className="text-sm text-gray-500 hover:text-gray-700 mb-3"
      >
        ← Conversations
      </button>
      <div className="h-[calc(var(--vh-full)-10rem-var(--tab-bar-space,0px))] min-h-[480px] border border-gray-200 rounded-lg overflow-hidden bg-white">
        <MessageThread key={id ?? 'none'} conversation={conversation} contact={null} />
      </div>
    </Layout>
  );
}
